export const CAS_BLOCK_TEST_ID = "cas-block-component";
